import { Component } from '@angular/core';


@Component({
    selector: 'soft-date-time-range-picker',
    imports: [],
    templateUrl: './date-time-range-picker.component.html',
    styleUrl: './date-time-range-picker.component.css'
})
export class DateTimeRangePickerComponent {}
